const configData = process.env;
const satsansEnvConfigString =
  configData?.REACT_APP_SATSANG_EVENT_CONFIG || null;
const satsangEnvConfig = satsansEnvConfigString
  ? JSON.parse(satsansEnvConfigString)
  : {};
const satsangEventConfigData = {};

try {
  satsangEventConfigData.template =
    satsangEnvConfig?.template || "eb824e70-bc5c-4f41-ac04-aa09890a1f7f";
  satsangEventConfigData.sector =
    satsangEnvConfig?.sector || "b2ff246d-06df-49a8-b68e-731e236a3bde";
  satsangEventConfigData.category =
    satsangEnvConfig?.category || "12770279-3c57-48c5-81d7-3e6ca4cd34ec";
  satsangEventConfigData.eventName = satsangEnvConfig?.eventName || "Satsangh";
  satsangEventConfigData.sessionName =
    satsangEnvConfig?.sessionName || "Satsangh";
} catch {
  satsangEventConfigData.template = "eb824e70-bc5c-4f41-ac04-aa09890a1f7f";
  satsangEventConfigData.sector = "b2ff246d-06df-49a8-b68e-731e236a3bde";
  satsangEventConfigData.category = "12770279-3c57-48c5-81d7-3e6ca4cd34ec";
  satsangEventConfigData.eventName = "Satsangh";
  satsangEventConfigData.sessionName = "Satsangh";
}

export default satsangEventConfigData;
